module.exports = __webpack_public_path__ + "static/Papa_Main_Version.5095f73b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/data/Papa_Main_Version.mp3
// module id = 213
// module chunks = 35783957827783